import React from 'react'
import { MultipleAnswer, Step } from '../../components'

const SUBJECTS = {
  key: 'teaches_subject',
  trackingKey: 'subjects',
  question: 'What subjects do you teach?',
  choices: [
    { icon: '📐', text: 'Mathematics', value: 'math' },
    { icon: '⚛️', text: 'Science', value: 'science' },
    { icon: '✍', text: 'English', value: 'english' },
    { icon: '🗣️', text: 'Languages', value: 'languages' },
    { icon: '🌎', text: 'Social Studies', value: 'social' },
    { icon: '🤖', text: 'Computer Science', value: 'compsci' },
    { icon: '🎨', text: 'Creative Arts', value: 'arts' },
    { icon: '❤️', text: 'PE/Health', value: 'health' },
    { icon: '📗', text: 'Special Education', value: 'spec_ed' },
    { text: 'Other', value: 'other' }
  ]
}

export const EducatorTeachedSubjects = ({ index }) => {
  return (
    <Step
      index={index}
      trackingKey={SUBJECTS.trackingKey}
      itemsCount={SUBJECTS.choices.length}
      mode='multiple'
      title={SUBJECTS.question}
      subtitle='Select all that apply (Required)'
    >
      {SUBJECTS.choices.map(({ icon, text, value }) => (
        <MultipleAnswer
          key={`${text}-${value}`}
          question={SUBJECTS.question}
          surveyKey={SUBJECTS.key}
          text={text}
          icon={icon}
          value={value}
        />
      ))}
    </Step>
  )
}
